import { http } from 'http';

export default {
  access: (partnerId, quoteId, params) =>
    http.post(`/bconnect/access/${partnerId}/${quoteId}`, params)
};
